import { MetaTags } from "@/services/metaTags";
import { CountryCode, FallbackCountryCode } from "@/services/translation";
import { RouteLocationNormalized } from "vue-router";

export const setLinkCanonical = async (route: RouteLocationNormalized) => {
  const path = route.fullPath;
  let canonicalUrl: string;
  const countryCodes = Object.values(CountryCode).join("|");
  const homepageRegex = new RegExp(`^/(${countryCodes})/?$`);
  if (path.match(homepageRegex)) {
    canonicalUrl = "/" + FallbackCountryCode;
  } else {
    const regex = new RegExp(`^/(${countryCodes})/`);
    canonicalUrl = path.replace(regex, "/" + FallbackCountryCode + "/");
  }
  const fullCanonicalUrl = window.location.origin + canonicalUrl;
  MetaTags.setLinkCanonical(fullCanonicalUrl);
};
